import React from 'react';
import './Services.css'
import web from './web.png'
import git from './git.png'
import seo from './seo.png'
import des from './des.png'
import ui from './ui.png'
import smm from './smm.png'
import Zoom from 'react-reveal/Zoom';


const ServicesMe = () => {
   
        return (
            <>
            <Zoom>
            <h1 className='text-center text-3xl'>Services</h1>
            <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    
    <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center  mb-5 flex-shrink-0">
          
          <img src={web} alt="myImage" />
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">WEB DEVELOPMENT</h2>
          <p className="leading-relaxed text-base">I'm extremely passionated about web development and design and love to work as a freelance designer and developer.</p>
        
        </div>
      </div>
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center rounded-3xl  mb-5 flex-shrink-0">
         <img src={git} alt="gitImage"/>
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">GIT & GITHUB</h2>
          <p className="leading-relaxed text-base">It is primarily used for source code management in software development, but it can be used to keep track of changes in any set of files.

</p>
         
        
        </div>
      </div>
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center  mb-5 flex-shrink-0">
         <img src={seo} alt="seoImage"/>
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">SEO</h2>
          <p className="leading-relaxed text-base">It is often about making small modifications to parts of your website. When viewed individually, these changes might seem like incremental improvements, but when combined with other optimizations, they could have a noticeable impact on your site's user experience and performance in organic search results. 

</p>
          
        </div>
      </div>
    </div>
  </div>
</section>
<section className="text-gray-600 body-font">
  <div className="container px-5 py-6 mx-auto">
    
    <div className="flex flex-wrap sm:-m-4 -mx-4 -mb-10 -mt-4 md:space-y-0 space-y-6">
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center  mb-5 flex-shrink-0">
          <img src={des} alt="designImage" />
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">LOGO DESIGN</h2>
          <p className="leading-relaxed text-base">I value simple content structure, clean design patterns, and thoughtful interactions.</p>
         
        </div>
      </div>
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center  mb-5 flex-shrink-0">
          <img src={ui} alt="uiDesign"/>
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">UI/UX DESIGN</h2>
          <p className="leading-relaxed text-base">I create User Interface designer for websites , mobile applications and web applications.

</p>
         
        </div>
      </div>
      <div className="p-4 md:w-1/3 flex flex-col text-center items-center">
        <div className="w-20 h-20 inline-flex items-center justify-center mb-5 flex-shrink-0">
          <img src={smm} alt="smmDesign" />
        </div>
        <div className="flex-grow">
          <h2 className="text-rose-500 text-lg title-font font-medium mb-3">SOCIAL MEDIA MANAGEMENT</h2>
          <p className="leading-relaxed text-base">I'm creative and can bring fresh ideas to the table.I'll be able to ensure that your business's brand is well represented on each social media platform.

</p>
          
        </div>
      </div>
    </div>
  </div>
</section>
</Zoom>
            </>
        );
    
}

export default ServicesMe;